import * as $ from 'jquery'

const $industryHeros = $('.js-industryHero')

if ($industryHeros.length) {
    $industryHeros.each(function() {
        const $this = $(this)
        const $tabButtons = $this.find('.js-tabButton')
        const $tabs = $this.find('.js-tab')

        $tabButtons.on('click', function() {
            $tabs.removeClass('-active')
            $tabButtons.removeClass('-active')

            const $thisButton = $(this)
            const tabID = $thisButton.data('tab')
            const $associatedTab = $this.find(`.js-tab[data-tab="${tabID}"]`)

            $thisButton.addClass('-active')
            $associatedTab.addClass('-active')
        })
    })

    // Scroll to tabbed section and open tab based on location hash 
    $(document).ready(function() {
        // First, let's start at the top 
        if (location.hash) {
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 1);
        }

        // Then scroll to the tabbed section and open the relevant tab 
        if(window.location.hash != "") {
            var tabSectionWrapper = $("#tabListWrapper"); // anchor for parent section 
            var windowLocationHash = window.location.hash; // get hash from URL 
            var tabSelectionHashButton = $(".js-tabButton" + windowLocationHash); // get tab with corresponding ID 

            $("html,body").delay(500).animate({scrollTop: tabSectionWrapper.offset().top -200}, 500); // scroll to section 
            tabSelectionHashButton.delay(500).click(); // click element specified by hash
        }
    });
}
